<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  import ApplicationState from "../../../../../Stores/applicationStates"
  import SmallList from "./smallList.svelte"
  import LargeList from "./largeList.svelte"
  import DeleteModal from "./deleteModal.svelte"
  import notify from "../../../../../Script/notify"
  import DuplicateConfirmation from "../../../Email/Shared/duplicateConfirmation.svelte"
  import { deleteRequest, getRequest, postRequest } from "../../../../../Script/apiMethods"
  /**
   * @type {import("../../../../../Stores/templatesList").Item}
   */
  export let template
  export let showLoading
  export let loadingText
  export let count

  let showDeleteModal = false

  /**
   * @type {Boolean} whether to show duplicate modal or not
   */
  let showDuplicateModal = false

  const deleteTemplate = async () => {
    try {
      showDeleteModal = false
      showLoading = true
      loadingText = `Deleting ${template.name} Badge Design Template`

      await deleteRequest(`/api/swagger/v2/templates/badges/${template.id}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      dispatch("fetchList")

      notify.success(`<strong style="hyphens: auto;">${template.name}</strong> deleted successfully`)
    } catch (error) {
      const info = "PAGE: Badge List\nEVENT: While deleting badge template"
      notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }

  const duplicateTemplate = async () => {
    try {
      showLoading = true
      showDuplicateModal = false
      loadingText = `Duplicating&nbsp;<strong>${template.name} Badge Design Template</strong>&nbsp;`

      const CONFIG = {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      }

      // Get selected badge data
      const { template: badgeTemp } = await getRequest(`/api/swagger/v2/templates/badges/${template.id}`, CONFIG)
      const badgeData = badgeTemp

      // Current badge list
      const badgeList = await getRequest(`/api/swagger/v2/templates/badges?limit=${count}&page=1&sort=-1&sortBy=date`, CONFIG)

      let tempArray = badgeList.templates.filter((badge) => badge.name.includes(`${badgeData.name}`))

      let copyCount = 0
      for (let i = 0; i < tempArray.length; i++) {
        if (badgeData.name.length + 4 == tempArray[i].name.length) copyCount++
      }

      let tempValue = ` ${copyCount ? `(${copyCount + 1})` : `(1)`}`

      // let tempValue = ` ${tempArray.length ? `(${tempArray.length + 1})` : `(1)`}`

      let remainingLength = 30 - tempValue.length

      // Make sure the badgeData.name doesn't exceed the remaining length
      let truncatedName = badgeData.name.slice(0, remainingLength)

      let templateName = truncatedName + tempValue

      let { created, modified, ...filteredData } = badgeData

      let reqBody = { ...filteredData, name: templateName }

      // Converting File
      const fileBlob = await getRequest(`${reqBody.uri}`, { responseType: "blob" })
      const badgeFile = new File([fileBlob], `Badge Design Template - ${Date.now()}`, {
        type: "image/png",
      })

      reqBody.file = badgeFile
      delete reqBody.uri

      // Create new badge template
      await postRequest("/api/swagger/v2/templates/badges", reqBody, {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": $ApplicationState.token,
        },
      })

      dispatch("fetchList")

      notify.success(`<strong>${templateName}</strong> created successfully.`)
    } catch (error) {
      console.error(error)
      // Show an error notification
      const info = "PAGE: Badge List\nEVENT: While duplicating badge template"
      notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }
</script>

{#if showDeleteModal}
  <DeleteModal
    on:click={() => {
      showDeleteModal = false
    }}
    {template}
    on:delete={deleteTemplate}
  />
{/if}

{#if $ApplicationState.fileListToggle}
  <div class="block">
    <SmallList
      {template}
      on:onDuplicate={() => (showDuplicateModal = true)}
      on:click={() => {
        showDeleteModal = true
      }}
    />
  </div>
{:else}
  <div class="hidden h-[320px] md:block">
    <LargeList
      {template}
      on:onDuplicate={() => (showDuplicateModal = true)}
      on:click={() => {
        showDeleteModal = true
      }}
    />
  </div>
  <div class="block md:hidden">
    <SmallList
      {template}
      on:onDuplicate={() => (showDuplicateModal = true)}
      on:click={() => {
        showDeleteModal = true
      }}
    />
  </div>
{/if}

{#if showDuplicateModal}
  <DuplicateConfirmation
    type="Badge Design"
    on:click={() => {
      showDuplicateModal = false
    }}
    on:duplicate={duplicateTemplate}
    templateName={template.name}
  />
{/if}
